module.exports = "/_next/static/images/mokubaza-food-5f7ca7307e2fafcdb41c1807b981ac90.png";